import React, { ReactElement } from 'react';

import { Filters } from '../../interfaces';
import { PpBreadcrumbs } from '../PpBreadcrumbs';

interface Props {
    hotelName?: string;
    filters: Filters;
}
export const HotelTopBar: React.FC<Props> = ({ hotelName, filters }): ReactElement<Props> => (
    <div className="u-mv16" data-testid="topBar">
        <PpBreadcrumbs hotelName={hotelName} filters={filters} />
    </div>
);
